namespace TabAurous.Finance {
    export interface PaymentRow {
        TransId?: number;
        EnteredBy?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        LedgerId?: number;
        LedgerName?: string;
        TotalAmount?: number;
        Narration?: string;
        VoucherTypeId?: number;
        UserId?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        TaxId?: number;
        Rate?: number;
        TaxAmount?: number;
        TdsTotal?: number;
        TaxLedgerId?: number;
        KnockOffTotal?: number;
        Details?: PaymentDetailsRow[];
        PartyBalance?: PartyBalanceRow[];
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        Pincode?: string;
        GstVat?: string;
        Pan?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace PaymentRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.Payment';
        export const deletePermission = 'Finance:Payment:Delete';
        export const insertPermission = 'Finance:Payment:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Payment:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            EnteredBy = "EnteredBy",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            TotalAmount = "TotalAmount",
            Narration = "Narration",
            VoucherTypeId = "VoucherTypeId",
            UserId = "UserId",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            TaxId = "TaxId",
            Rate = "Rate",
            TaxAmount = "TaxAmount",
            TdsTotal = "TdsTotal",
            TaxLedgerId = "TaxLedgerId",
            KnockOffTotal = "KnockOffTotal",
            Details = "Details",
            PartyBalance = "PartyBalance",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            Pincode = "Pincode",
            GstVat = "GstVat",
            Pan = "Pan",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
